export default __webpack_public_path__ + "static/media/iPermit_roof.720a2d04.svg";